module.exports = __webpack_public_path__ + "img/ic_equipment.964c98df.svg";